const enum ApiModelStoreCategoryEnum {
  publicService = 'public-service',
  charitableOrg = 'charitable-organization',
  charitableOrgDonationInitiative = 'charitable-organization-donations-initiative',
  virtualServiceProducts = 'virtual-service-and-products',
  consultingTrainingServices = 'consulting-and-training-services',
}

export default ApiModelStoreCategoryEnum;
